// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO: use tui calendar theme instead, quick fix rush to prod */
.tui-full-calendar-floating-layer {
    height: auto;
}

.tui-full-calendar-month-more-list .tui-full-calendar-weekday-schedule-bullet {
    margin-top: -2px;
    top: 0 !important;
}

#simple-tabpanel-0 {
    position: absolute;
    width: 320px;
}

#eeBillboard>div:first-child {
    position: relative;
}

/**
 * Ticket: #10122
 * @see javascript/src/common-client2/src/style.scss:169
 */
.MuiCheckbox-colorPrimary.Mui-checked,
.MuiCheckbox-colorSecondary.Mui-checked {
    color: #3366FF !important;
}`, "",{"version":3,"sources":["webpack://./src/common/styles/custom.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;EAGE;AACF;;IAEI,yBAAyB;AAC7B","sourcesContent":["/* TODO: use tui calendar theme instead, quick fix rush to prod */\r\n.tui-full-calendar-floating-layer {\r\n    height: auto;\r\n}\r\n\r\n.tui-full-calendar-month-more-list .tui-full-calendar-weekday-schedule-bullet {\r\n    margin-top: -2px;\r\n    top: 0 !important;\r\n}\r\n\r\n#simple-tabpanel-0 {\r\n    position: absolute;\r\n    width: 320px;\r\n}\r\n\r\n#eeBillboard>div:first-child {\r\n    position: relative;\r\n}\r\n\r\n/**\r\n * Ticket: #10122\r\n * @see javascript/src/common-client2/src/style.scss:169\r\n */\r\n.MuiCheckbox-colorPrimary.Mui-checked,\r\n.MuiCheckbox-colorSecondary.Mui-checked {\r\n    color: #3366FF !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
